import type { AnimationProperties, AnimationsKit } from '../../types';

const name = 'BaseFade';
const properties: Partial<AnimationProperties> = {};

function animate(
  kit: AnimationsKit,
  elements: HTMLElement[] | HTMLElement | HTMLCollection,
  duration: number = 0,
  delay: number = 0,
  { lazy = false, to = {}, from = {}, ...params }: any = {},
) {
  if (to.opacity > 0) {
    to.autoAlpha = to.opacity;
    delete to.opacity;
  }

  if (from.opacity > 0) {
    from.autoAlpha = from.opacity;
    delete from.opacity;
  }

  return kit.engine.tween(
    elements,
    { duration, delay, lazy, to, from, ...params },
    ['opacity', 'autoAlpha'],
  );
}

export { name, properties, animate };
